export const SCRIBANE_BLACK = 'var(--scribane-black)';
export const SCRIBANE_BLUE = 'var(--scribane-black)';
export const SCRIBANE_GREEN = 'var(--scribane-green)';

export const COLOR_WHITE = 'var(--color-white)';

export const COLOR_SUCCESS = 'var(--color-success)';
export const COLOR_SUCCESS_HOVER = 'var(--color-success-hover)';
export const COLOR_DANGER = 'var(--color-danger)';
export const COLOR_DANGER_HOVER = 'var(--color-danger-hover)';
export const COLOR_WARNING = 'var(--color-warning)';
export const COLOR_INFO = 'var(--color-info)';

export const COLOR_GRAY_100 = 'var(--color-gray-100)';
export const COLOR_GRAY_400 = 'var(--color-gray-400)';
export const COLOR_GRAY_700 = 'var(--color-gray-700)';


export const COLOR_OVERLAY = 'var(--color-overlay)';
export const COLOR_OVERLAY_LIGHT = 'var(--color-overlay-light)';

export const COLOR_SUCCESS_ALPHA_30 = 'var(--color-success-alpha-30)';
export const COLOR_DANGER_ALPHA_30 = 'var(--color-danger-alpha-30)';
export const COLOR_WARNING_ALPHA_30 = 'var(--color-warning-alpha-30)';
export const COLOR_WARNING_ALPHA_15 = 'var(--color-warning-alpha-15)';

export const COLOR_FORMATTING_BAR_BG = 'var(--color-formatting-bar-bg)';
export const COLOR_FORMATTING_BAR_SEPARATOR = 'var(--color-formatting-bar-separator)';
export const COLOR_FORMATTING_BAR_TEXT = 'var(--color-formatting-bar-text)';
export const COLOR_FORMATTING_BAR_TEXT_ACTIVE = 'var(--color-formatting-bar-text-active)';
export const COLOR_FORMATTING_BAR_HOVER = 'var(--color-formatting-bar-hover)';

export const COLOR_SUGGESTION_STRENGTH = 'var(--color-suggestion-strength)';
export const COLOR_SUGGESTION_ORTHOGRAPHIC = 'var(--color-suggestion-orthographic)';
export const COLOR_SUGGESTION_STYLE = 'var(--color-suggestion-style)';
export const COLOR_SUGGESTION_USER_EDIT = 'var(--color-suggestion-user-edit)';
export const COLOR_SUGGESTION_USER_EDIT_ALPHA_30 = 'var(--color-suggestion-user-edit-alpha-30)';

export const COLOR_STATUS_APPLIED_BG = 'var(--color-status-applied-bg)';
export const COLOR_STATUS_APPLIED_TEXT = 'var(--color-status-applied-text)';
export const COLOR_STATUS_REJECTED_BG = 'var(--color-status-rejected-bg)';
export const COLOR_STATUS_REJECTED_TEXT = 'var(--color-status-rejected-text)';
export const COLOR_STATUS_PENDING_BG = 'var(--color-status-pending-bg)';
export const COLOR_STATUS_PENDING_TEXT = 'var(--color-status-pending-text)';
export const COLOR_STATUS_REPORTED_BG = 'var(--color-status-reported-bg)';
export const COLOR_STATUS_REPORTED_TEXT = 'var(--color-status-reported-text)';
export const COLOR_STATUS_ERROR_BG = 'var(--color-status-error-bg)';
export const COLOR_STATUS_ERROR_TEXT = 'var(--color-status-error-text)';

export const COLOR_RESOURCE_TAG_CHARACTER_BG = 'var(--color-resource-tag-character-bg)';
export const COLOR_RESOURCE_TAG_CHARACTER_TEXT = 'var(--color-resource-tag-character-text)';
export const COLOR_RESOURCE_TAG_CHARACTER_BORDER = 'var(--color-resource-tag-character-border)';
export const COLOR_RESOURCE_TAG_LOCATION_BG = 'var(--color-resource-tag-location-bg)';
export const COLOR_RESOURCE_TAG_LOCATION_TEXT = 'var(--color-resource-tag-location-text)';
export const COLOR_RESOURCE_TAG_LOCATION_BORDER = 'var(--color-resource-tag-location-border)';
export const COLOR_RESOURCE_TAG_TAG_BG = 'var(--color-resource-tag-tag-bg)';
export const COLOR_RESOURCE_TAG_TAG_TEXT = 'var(--color-resource-tag-tag-text)';
export const COLOR_RESOURCE_TAG_TAG_BORDER = 'var(--color-resource-tag-tag-border)';
export const COLOR_RESOURCE_TAG_STORYLINE_BG = 'var(--color-resource-tag-storyline-bg)';
export const COLOR_RESOURCE_TAG_STORYLINE_TEXT = 'var(--color-resource-tag-storyline-text)';
export const COLOR_RESOURCE_TAG_STORYLINE_BORDER = 'var(--color-resource-tag-storyline-border)';

export const COLOR_FEATURE_EXPORT_PDF_BG = 'var(--color-feature-export-pdf-bg)';
export const COLOR_FEATURE_EXPORT_PDF_TEXT = 'var(--color-feature-export-pdf-text)';
export const COLOR_FEATURE_EXPORT_PDF_CHART = 'var(--color-feature-export-pdf-chart)';
export const COLOR_FEATURE_EXPORT_WORD_BG = 'var(--color-feature-export-word-bg)';
export const COLOR_FEATURE_EXPORT_WORD_TEXT = 'var(--color-feature-export-word-text)';
export const COLOR_FEATURE_EXPORT_WORD_CHART = 'var(--color-feature-export-word-chart)';
export const COLOR_FEATURE_IMPORT_BG = 'var(--color-feature-import-bg)';
export const COLOR_FEATURE_IMPORT_TEXT = 'var(--color-feature-import-text)';
export const COLOR_FEATURE_IMPORT_CHART = 'var(--color-feature-import-chart)';
export const COLOR_FEATURE_CHARACTERS_ANALYSIS_BG = 'var(--color-feature-characters-analysis-bg)';
export const COLOR_FEATURE_CHARACTERS_ANALYSIS_TEXT = 'var(--color-feature-characters-analysis-text)';
export const COLOR_FEATURE_CHARACTERS_ANALYSIS_CHART = 'var(--color-feature-characters-analysis-chart)';
export const COLOR_FEATURE_CHAPTER_ANALYSIS_BG = 'var(--color-feature-chapter-analysis-bg)';
export const COLOR_FEATURE_CHAPTER_ANALYSIS_TEXT = 'var(--color-feature-chapter-analysis-text)';
export const COLOR_FEATURE_CHAPTER_ANALYSIS_CHART = 'var(--color-feature-chapter-analysis-chart)';
export const COLOR_FEATURE_SYNONYMS_BG = 'var(--color-feature-synonyms-bg)';
export const COLOR_FEATURE_SYNONYMS_TEXT = 'var(--color-feature-synonyms-text)';
export const COLOR_FEATURE_SYNONYM_SELECTED_BG = 'var(--color-feature-synonym-selected-bg)';
export const COLOR_FEATURE_SYNONYM_SELECTED_TEXT = 'var(--color-feature-synonym-selected-text)';
export const COLOR_FEATURE_DOCUMENT_CHAT_BG = 'var(--color-feature-document-chat-bg)';
export const COLOR_FEATURE_DOCUMENT_CHAT_TEXT = 'var(--color-feature-document-chat-text)';
export const COLOR_FEATURE_DOCUMENT_CHAT_CHART = 'var(--color-feature-document-chat-chart)';
export const COLOR_FEATURE_DOCUMENT_SUGGESTIONS_BG = 'var(--color-feature-document-suggestions-bg)';
export const COLOR_FEATURE_DOCUMENT_SUGGESTIONS_TEXT = 'var(--color-feature-document-suggestions-text)';
export const COLOR_FEATURE_DOCUMENT_SUGGESTIONS_CHART = 'var(--color-feature-document-suggestions-chart)';
export const COLOR_FEATURE_COMMENT_BG = 'var(--color-feature-comment-bg)';
export const COLOR_FEATURE_COMMENT_TEXT = 'var(--color-feature-comment-text)';
export const COLOR_FEATURE_COMMENT_CHART = 'var(--color-feature-comment-chart)';
export const COLOR_FEATURE_LOCATIONS_ANALYSIS_BG = 'var(--color-feature-locations-analysis-bg)';
export const COLOR_FEATURE_LOCATIONS_ANALYSIS_TEXT = 'var(--color-feature-locations-analysis-text)';
export const COLOR_FEATURE_LOCATIONS_ANALYSIS_CHART = 'var(--color-feature-locations-analysis-chart)';
export const COLOR_FEATURE_LOCATION_ANALYSIS_BG = 'var(--color-feature-location-analysis-bg)';
export const COLOR_FEATURE_LOCATION_ANALYSIS_TEXT = 'var(--color-feature-location-analysis-text)';
export const COLOR_FEATURE_LOCATION_ANALYSIS_CHART = 'var(--color-feature-location-analysis-chart)';
export const COLOR_FEATURE_TECHNICAL_SHEET_REGENERATION_BG = 'var(--color-feature-technical-sheet-regeneration-bg)';
export const COLOR_FEATURE_TECHNICAL_SHEET_REGENERATION_TEXT = 'var(--color-feature-technical-sheet-regeneration-text)';
export const COLOR_FEATURE_TECHNICAL_SHEET_REGENERATION_CHART = 'var(--color-feature-technical-sheet-regeneration-chart)';
export const COLOR_FEATURE_RESOURCE_ADDITION_BG = 'var(--color-feature-resource-addition-bg)';
export const COLOR_FEATURE_RESOURCE_ADDITION_TEXT = 'var(--color-feature-resource-addition-text)';
export const COLOR_FEATURE_RESOURCE_ADDITION_CHART = 'var(--color-feature-resource-addition-chart)';
export const COLOR_FEATURE_RESOURCE_ANALYSIS_BG = 'var(--color-feature-resource-analysis-bg)';
export const COLOR_FEATURE_RESOURCE_ANALYSIS_TEXT = 'var(--color-feature-resource-analysis-text)';
export const COLOR_FEATURE_RESOURCE_ANALYSIS_CHART = 'var(--color-feature-resource-analysis-chart)';
export const COLOR_FEATURE_WEB_SEARCH_BG = 'var(--color-feature-web-search-bg)';
export const COLOR_FEATURE_WEB_SEARCH_TEXT = 'var(--color-feature-web-search-text)';
export const COLOR_FEATURE_WEB_SEARCH_CHART = 'var(--color-feature-web-search-chart)';
export const COLOR_FEATURE_USER_CREATED_BG = 'var(--color-feature-user-created-bg)';
export const COLOR_FEATURE_USER_CREATED_TEXT = 'var(--color-feature-user-created-text)';
export const COLOR_FEATURE_USER_CREATED_CHART = 'var(--color-feature-user-created-chart)';
export const COLOR_FEATURE_EXAMPLE_PROJECT_SEEDED_BG = 'var(--color-feature-example-project-seeded-bg)';
export const COLOR_FEATURE_EXAMPLE_PROJECT_SEEDED_TEXT = 'var(--color-feature-example-project-seeded-text)';
export const COLOR_FEATURE_EXAMPLE_PROJECT_SEEDED_CHART = 'var(--color-feature-example-project-seeded-chart)';
export const COLOR_FEATURE_PLAN_UPGRADED_BG = 'var(--color-feature-plan-upgraded-bg)';
export const COLOR_FEATURE_PLAN_UPGRADED_TEXT = 'var(--color-feature-plan-upgraded-text)';
export const COLOR_FEATURE_PLAN_UPGRADED_CHART = 'var(--color-feature-plan-upgraded-chart)';
export const COLOR_FEATURE_DEFAULT_BG = 'var(--color-feature-default-bg)';
export const COLOR_FEATURE_DEFAULT_TEXT = 'var(--color-feature-default-text)';
export const COLOR_FEATURE_DEFAULT_CHART = 'var(--color-feature-default-chart)';

